import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'

export const mapFieldRiskOwnerFilter = (item, index) => {
  return {
    ...item,
    index,
    key: uuidv4(),
    id: item?.level_org_code,
    name: item?.level_org_name,
  }
}

export const getRiskOwnerFilterListApi = () => {
  const config = {
    method: 'get',
    url: '/api/v1/filters/risk_owner_org',
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0 && _.isArray(res.data)) {
        return responseSuccess({ data: _.map(res.data, mapFieldRiskOwnerFilter) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
